/**
 * Chart Component
 * Wrapper for Chart.js with Telegram theming
 */

import React from 'react';
import styled from 'styled-components';

const ChartContainer = styled.div`
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  margin: var(--spacing-md) 0;
`;

const ChartTitle = styled.h3`
  font-size: var(--font-lg);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  margin-bottom: var(--spacing-md);
`;

const ChartPlaceholder = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--font-sm);
`;

interface ChartProps {
  title?: string;
  type?: 'line' | 'bar' | 'pie';
  data?: any;
  height?: number;
}

const Chart: React.FC<ChartProps> = ({ title, type = 'line', height = 200 }) => {
  return (
    <ChartContainer>
      {title && <ChartTitle>{title}</ChartTitle>}
      <ChartPlaceholder style={{ height: `${height}px` }}>
        Chart ({type}) - Data visualization coming soon
      </ChartPlaceholder>
    </ChartContainer>
  );
};

export default Chart;
